<style scoped>
@import url("../assets/css/cj.css");
</style>

<template>
    <div :class="is_weixin || is_app?'':'common-home-content'">
        <div class="home-header" v-if="!is_weixin && !is_app">
            <button class="page-back" @click="pageback()"><span></span></button>
            <span class="title">智慧开方</span>
        </div>
        <div class="page-loading" v-show="!show">
            <div class="loading-content">
                <img src="../assets/images/page_loading.gif">
                <p class="loading-title">正在加载...</p>
            </div>
        </div>
        <div v-show="show">
            <div class="tab-container clearfix ice_bg">
                <div class="zhen-tabs">
                    <ul class="tabs-main clearfix">
                        <li><router-link class="a" to="/">症状</router-link></li>
                        <li><router-link class="a actived" to="/cj">疾病</router-link></li>
                        <li><router-link class="a" to="ks">科室</router-link></li>
                    </ul>
                </div>
            </div>
            <div class="ice_bg space_pr pb15 space_pl">
                <div
                    v-for="(disease, index) in diseases"
                    :key="index"   
                >
                <h2 class="zhen-group-title word_sl font_2">{{disease.name}}</h2>
                <ul class="zhen-group clearfix">
                    <li class="fl"
                        v-for="(child, index) in disease.value"
                        :key="index"
                    >
                        <div class="zhen-group-disease a"
                            @click="link(child.name)"
                        >
                            <span class="pr ib ellipsis">{{child.name}}</span>
                            <span class="free_icon_r" v-if="locData.free.indexOf(child.name) > -1"></span>
                        </div>
                    </li>
                </ul>
                </div>
                <div
                    v-for="(disease, index) in seasons"
                    :key="index"   
                >
                <h2 class="zhen-group-title word_sl font_2">{{disease.name}}</h2>
                <ul class="zhen-group clearfix">
                    <li class="fl"
                        v-for="(child, index) in disease.value"
                        :key="index"
                    >
                        <div class="zhen-group-disease a"
                            @click="link(child.name)"
                        >
                            <span class="pr ib ellipsis">{{child.name}}</span>
                            <span class="free_icon_r" v-if="locData.free.indexOf(child.name) > -1"></span>
                        </div>
                    </li>
                </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {deviceType} from '../utils/deviceType'
export default {
  data() {
    return {
      locData: {},
      diseases: [],
      seasons: [],
      is_app: deviceType.isApp,
      is_weixin: deviceType.isWeiXin,
      show: false
    };
  },
  created() {
      this.loadinit();
      window.appBack = ()=> this.pageback();
  },
  methods: {
      loadinit(){
        var that = this;
        that.$api.get("/zhen/old/cj").then(function(res) {
            that.locData = res.data;
            for(var k in that.locData.popular){
                that.diseases.push({
                    name: k,
                    value: that.locData.popular[k]
                });
            }
            for(var k2 in that.locData.season){
                that.seasons.push({
                    name: k2,
                    value: that.locData.season[k2]
                });
            }
            that.show = true;
        });
      },
      link(id){
          this.$router.push({ path: "/?q=" + id});
      },
      pageback(){
          if(this.is_app){
              return null;
          }else{
              this.$router.push({ path: "/"});
          }
      }  
  }
}
</script>

